export type ViewMode = "cards" | "list";

export function isViewMode(value: unknown): value is ViewMode {
  return value === "cards" || value === "list";
}
